<template>
	<el-drawer title="结款单明细" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
		@close="close">
		<div class="drawer-content" v-loading="dataLoading">
			<template v-if="data">
				<!-- 收款信息 -->
				<div class="group">
					<div class="page-group-title"><span>收款信息</span></div>
					<template v-if="data.receivablesInfo">
						<table class="info-table MT20" width="100%">
							<tr>
								<th>收款联系人姓名</th>
								<td>{{ data.receivablesInfo.userName }}</td>
								<th>收款联系人手机</th>
								<td>{{ data.receivablesInfo.userTelephone }}</td>
							</tr>
							<tr>
								<th>收款联系人邮箱</th>
								<td>{{ data.receivablesInfo.userEmail }}</td>
								<th>通讯地址</th>
								<td>{{ data.receivablesInfo.address }}</td>
							</tr>
							<tr>
								<th>银行</th>
								<td>{{ data.receivablesInfo.bankName }}</td>
								<th>开户网点</th>
								<td>{{ data.receivablesInfo.bankAddress }}</td>
							</tr>
							<tr>
								<th>卡号</th>
								<td>{{ data.receivablesInfo.bankCardId }}</td>
								<th>账户名</th>
								<td>{{ data.receivablesInfo.bankAccount }}</td>
							</tr>
							<tr>
								<th>账户性质</th>
								<td>{{ accountTypeText }}</td>
								<th>合同编号</th>
								<td>{{ data.receivablesInfo.contractSn }}</td>
							</tr>
						</table>
					</template>
					<div v-else class="color-danger">
						<span class="el-icon-warning"></span> 请完善结款方的演出收款信息
					</div>
				</div>

				<!-- 基本信息 -->
				<div class="group MT20">
					<div class="page-group-title"><span>基本信息</span></div>
					<table class="info-table MT20" width="100%" v-if="data.baseInfo">
						<tr v-for="(item, index) in data.baseInfo" :key="index">
							<th>{{ item.name }}</th>
							<td>{{ item.value }}</td>
						</tr>
					</table>
				</div>

				<!-- 结算场次 -->
				<div class="group MT20" v-if="hasSessionItems">
					<div class="page-group-title">
						<span>结算场次</span>
						<small>
							（已申请 <span class="color-danger">{{ data.applySessionNum }}</span>
							已结款 <span class="color-danger">{{ data.playSessionNum }}</span>
							未申请 <span class="color-danger">{{ data.notApplySessionNum }}</span>）
						</small>
					</div>
					<table class="info-table MT20" width="100%">
						<tr>
							<th>场次名称</th>
							<th>场次结束时间</th>
						</tr>
						<tr v-for="(item, index) in data.sessionItems" :key="index">
							<td>{{ item.name }}</td>
							<td>{{ item.value }}</td>
						</tr>
					</table>
				</div>

				<!-- 通票信息 -->
				<div class="group MT20" v-if="hasThroughItems">
					<div class="page-group-title">
						<span>涉及通票 通票会在整场演出结束才可申请</span>
					</div>
					<table class="info-table MT20" width="100%">
						<tr>
							<th>通票名称</th>
							<th>关联场次数</th>
						</tr>
						<tr v-for="(item, index) in data.throughItems" :key="index">
							<td>{{ item.name }}</td>
							<td>{{ item.value }}</td>
						</tr>
					</table>
				</div>

				<!-- 结算参考 -->
				<div class="group MT20">
					<div class="page-group-title"><span>结算参考</span></div>
					<div v-if="data.referenceInfo">
						<span class="color-danger">预计结款</span> = 收入合计-扣款合计
						<span class="el-icon-right"></span>
						{{ data.referenceInfo.incomeTotalAmount }}-{{ data.referenceInfo.deductionTotalAmount }}
						<span class="color-danger"> = {{ data.referenceInfo.expectedTotalAmount }}</span>
					</div>

					<!-- 秀动收入相关 -->
					<FinanceTable v-if="hasTotalList" title="秀动收入相关" :data="data.referenceInfo.totalList"
						class="MT20" />

					<!-- B类收入相关 -->
					<FinanceTable v-if="hasIncomeList" title="B类收入相关" :data="data.referenceInfo.incomeList"
						class="MT20" />

					<!-- 结款扣款项 -->
					<FinanceTable v-if="hasDeductionList" title="结款扣款项" :data="data.referenceInfo.deductionList"
						class="MT20" />
				</div>

				<!-- 结算单列表 -->
				<div class="group MT20" v-if="hasSettlementDoc">
					<div class="page-group-title"><span>结算单列表</span></div>
					<table class="info-table MT20" width="100%">
						<tr>
							<th>结算单ID</th>
							<th>结算场次</th>
							<th>结算单状态</th>
							<th>结算单时间</th>
							<th>金额</th>
						</tr>
						<tr v-for="(item, index) in data.settlementDocInfo" :key="index">
							<td>{{ item.id }}</td>
							<td style="width: 200px;">{{ item.settlementSession }}</td>
							<td>{{ item.settlementStatus }}</td>
							<td>
								<p>申请打款：{{ item.createTime }}</p>
								<p>实际打款：{{ item.playTime }}</p>
							</td>
							<td>
								<p>结款金额：{{ item.settlementAmount }}</p>
								<p>实际打款：{{ item.playAmount }}</p>
							</td>
						</tr>
					</table>
				</div>

				<!-- 额外技术服务费明细 -->
				<div class="group MT20" v-if="hasTechnicalServiceFee">
					<div class="page-group-title">
						<span>额外技术服务费明细（总金额{{ data.referenceInfo.technicalServiceFeeAmountStr }}）</span>
					</div>
					<table class="info-table MT20" width="100%">
						<tr>
							<th>费用项目</th>
							<th>金额</th>
						</tr>
						<tr v-for="(item, index) in data.referenceInfo.technicalServiceFeeList" :key="index">
							<td>{{ item.name }}</td>
							<td>{{ item.value }}</td>
						</tr>
					</table>
				</div>
				<!-- 打款信息 -->
				<div class="group MT20">
					<div class="page-group-title"><span>打款信息</span></div>
					<el-card v-if="isPendingPayment">
						<!-- 待打款 -->
						<SettlementEdit ref="settlementEdit" :data.sync="data"
							:audiId.sync="showdata.id" :btnLoading="btnLoading" :key="formKey"
							@submit-success="handleSubmitSuccess" @update:btnLoading="val => btnLoading = val" />
					</el-card>
						<!-- 已打款 -->
						<table class="info-table" width="100%" v-if="isPaid">
							<tr>
								<th>申请结款时间</th>
								<td>{{ data.playInfo.createTime }}</td>
								<th>申请结款备注</th>
								<td>{{ data.playInfo.applyDesc }}</td>
							</tr>
							<tr>
								<th>打款流水号</th>
								<td>{{ data.playInfo.playPriceNo }}</td>
								<th>实际打款金额</th>
								<td>{{ data.playInfo.playPriceTicketFormat }}</td>
							</tr>
							<tr>
								<th>打款时间</th>
								<td>{{ data.playInfo.playTime }}</td>
								<th>金额不一致原因</th>
								<td>{{ data.playInfo.inconsistentDesc }}</td>
							</tr>
							<tr>
								<th>打款备注</th>
								<td>{{ data.playInfo.playDesc }}</td>
								<th>打款截图</th>
								<td>
									<div v-if="hasPlayPic" class="img">
										<el-image v-for="(item, index) in data.playInfo.playPic" :key="index"
											:src="item" fit="cover" :preview-src-list="data.playInfo.playPic" />
									</div>
								</td>
							</tr>
						</table>
					
				</div>
			</template>
		</div>

		<!-- 底部按钮 -->
		<div class="drawer-footer">
			<el-button @click="close">取 消</el-button>
			<el-button type="primary" v-if="canReject" :loading="rejectLoading" @click="handleReject">
				驳回结款申请
			</el-button>
			<el-button type="primary" v-if="isPendingPayment" :loading="btnLoading" @click="handleSubmit">
				提 交
			</el-button>
			<el-button type="primary" :loading="loadbtnLoading" @click="handleDownload">
				下载结算单
			</el-button>
		</div>
	</el-drawer>
</template>

<script>
	import SettlementEdit from './settlementEdit';
	import FinanceTable from './financeTable';
	import {
			downloadFileTmp
		} from '@/assets/js/commonApi.js';
	export default {
		name: 'SettlementDetailDrawer',
		components: {
			SettlementEdit,
			FinanceTable
		},
		data() {
			return {
				drawerShow: false,
				dataLoading: false,
				btnLoading: false,
				loadbtnLoading: false,
				rejectLoading: false,
				id: '',
				data: null,
				showdata: null,
				formKey: Date.now()
			};
		},
		computed: {
			// 账户类型文本
			accountTypeText() {
				return this.data && this.data.receivablesInfo ?
					(this.data.receivablesInfo.accountType == 1 ? '企业' : '个人') :
					'';
			},
			// 是否有场次信息
			hasSessionItems() {
				return this.data &&
					this.data.throughItems &&
					this.data.sessionItems &&
					this.data.sessionItems.length > 0;
			},
			// 是否有通票信息
			hasThroughItems() {
				return this.data &&
					this.data.throughItems &&
					this.data.throughItems.length > 0;
			},
			// 是否有秀动收入列表
			hasTotalList() {
				return this.data &&
					this.data.referenceInfo &&
					this.data.referenceInfo.totalList &&
					this.data.referenceInfo.totalList.length > 0;
			},
			// 是否有B类收入列表
			hasIncomeList() {
				return this.data &&
					this.data.referenceInfo &&
					this.data.referenceInfo.incomeList &&
					this.data.referenceInfo.incomeList.length > 0;
			},
			// 是否有扣款列表
			hasDeductionList() {
				return this.data &&
					this.data.referenceInfo &&
					this.data.referenceInfo.deductionList &&
					this.data.referenceInfo.deductionList.length > 0;
			},
			// 是否有结算单
			hasSettlementDoc() {
				return this.data &&
					this.data.settlementDocInfo &&
					this.data.settlementDocInfo.length > 0;
			},
			// 是否有技术服务费
			hasTechnicalServiceFee() {
				return this.data &&
					this.data.referenceInfo &&
					this.data.referenceInfo.technicalServiceFeeList &&
					this.data.referenceInfo.technicalServiceFeeList.length > 0;
			},
			// 是否有打款截图
			hasPlayPic() {
				return this.data &&
					this.data.playInfo &&
					this.data.playInfo.playPic &&
					this.data.playInfo.playPic.length > 0;
			},
			// 是否待打款
			isPendingPayment() {
				return this.drawerShow &&
					this.data &&
					this.data.playInfo &&
					this.data.playInfo.status == 1;
			},
			// 是否已打款
			isPaid() {
				return this.data &&
					this.data.playInfo &&
					this.data.playInfo.status == 2;
			},
			// 是否可以驳回
			canReject() {
				return this.data &&
					this.data.isBalance == 1 &&
					this.data.isApplySettlement == 1;
			}
		},
		methods: {
			// 关闭
			close() {
				this.formKey = Date.now();
				this.data = null;
				this.showdata = null;
				this.drawerShow = false;
			},

			// 提交成功处理
			handleSubmitSuccess() {
				this.$emit('onUpdate');
				this.close();
			},

			// 显示
			show(data) {
				this.showdata = data || null;
				this.data = data || null;
				this.id = data && data.id ? data.id : '';
				this.btnLoading = false;
				if (data && data.id) {
					this.fetchData();
				}
			},

			// 获取详情数据
			fetchData() {
				var self = this;
				self.dataLoading = true;

				self.$request({
					url: '/activityFinanceSettle/settlementDoc/receivablesInfo',
					params: {
						id: self.id
					},
					method: 'post'
				}).then(function(res) {
					var data = res.data;
					if (data.state == 1 && data.result) {
						self.data = self.formatData(data.result);
						self.drawerShow = true;
					} else {
						self.$message.error(data.msg || '获取详情失败，请重试');
					}
				}).catch(function() {
					self.$message.error('获取详情失败，请重试');
				}).finally(function() {
					self.dataLoading = false;
				});
			},

			// 格式化数据
			formatData(result) {
				var playPic = result.playPic || [];
				var fileList = [];

				for (var i = 0; i < playPic.length; i++) {
					fileList.push({
						url: playPic[i]
					});
				}

				return {
					...result,
					playPic: playPic,
					fileList: fileList
				};
			},

			// 处理驳回
			handleReject() {
				var self = this;
				self.rejectLoading = true;

				self.$request({
					url: '/activityFinanceSettle/dismiss',
					params: {
						id: self.id
					},
					method: 'post'
				}).then(function(res) {
					var data = res.data;
					if (data.state == 1) {
						self.$message.success('操作成功');
						self.close();
					} else {
						self.$message.error(data.msg || '操作失败，请重试');
					}
				}).catch(function() {
					self.$message.error('操作失败，请重试');
				}).finally(function() {
					self.rejectLoading = false;
				});
			},

			// 下载结算单
			handleDownload() {
				var self = this;
				self.loadbtnLoading = true;

				self.$request({
					url: '/activityFinanceSettle/exportSettlement',
					method: 'POST',
					params: {
						id: self.id
					}
				}).then(function(res) {
					var data = res.data;
					if (data.state == 1 && data.result) {
						var filePath = data.result.url;
						var fileType = self.$utils.getFileType(filePath);
						downloadFileTmp(filePath, self.id + '结算单.' + fileType);
					} else {
						self.$message.error(data.msg || '下载失败');
					}
				}).catch(function() {
					self.$message.error('请求错误');
				}).finally(function() {
					self.loadbtnLoading = false;
				});
			},

			// 提交表单
			handleSubmit() {
				this.$refs.settlementEdit.onSubmit();
			}
		}
	};
</script>

<style lang="scss" scoped>
	.info-table {
		th {
			min-width: 100px;
			text-align: left;
			white-space: nowrap;
			padding: 8px 0 8px 10px;
		}

		td {
			min-width: 100px;
			border-right: 1px solid #eee;
			padding: 8px 0 8px 10px;
			white-space: normal;
		}
	}

	.hand {
		cursor: pointer;
	}

	.ML5 {
		margin-left: 5px;
	}

	.img {
		.el-image {
			width: 100px;
			height: 100px;
			margin-right: 10px;
		}
	}
</style>